<template>
  <div>
    <EditRelative ref="EditRelative" @update="updateData"></EditRelative>
    <SearchRelative ref="SearchRelative" @AddAccountChoose="AddAccountChoose" @BuildNewAccount="buildNewAccount"  @AddRelative="AddRelative"></SearchRelative>
    <transition-group tag="div" class="enableList mt05x bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E" :class="{pr3x:account.acountList.length>0,pr1x:account.acountList.length==0}" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
        <button v-if="account.acountList.length>0" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>
        <TagBox v-for="(account,index) in account.acountList" :key="account.entityRelId" :styleType="'tag'" :val="account.name" :data="account" @Remove="onRemove(account.entityRelId,index)" ></TagBox>
        <button :key="'add'" class="lh15 cMain" type="button" @click.stop="_showList">{{'+'+getLanguageStr('word1546','用户')}}</button>
		</transition-group>
    <div class="w50pct pt05x bdSub boxR-light pl05x pr05x" v-show="showAccount" @mouseenter="showAccountMousePos=true"  @mouseleave="showAccountMousePos=false" v-clickoutside="handleClose">
        <ul class="bdLight-bottom_E chooseList">
            <!-- <li><a class="dpB" @click="existAccount">{{getLanguageStr('word1682','选择已添加用户')}}</a></li> -->
            <li><a class="dpB" @click="addAccount">{{getLanguageStr('word1688','添加已有用户')}}</a></li>
            <li><a class="dpB" @click="buildNewAccount">{{getLanguageStr('cmd100','创建新用户')}}</a></li>
        </ul>
    </div>
    <div class="mt05x bdSub boxR-light ofH" v-show="existAccInfo.show" :class="{w60pct:type=='normal'}"@mouseenter="showAccountMousePos=true"  @mouseleave="showAccountMousePos=false" v-clickoutside="handleClose">
      <div class="ml1x mr1x pt05x pb05x taC inputWrap bdSub-bottom">
				<InputText v-model="existAccInfo.searchKey" class="w80pct dpIB bgContent" name="relevanceExistAccount" :placeholder="getLanguageStr('crm39','请输入姓名/手机号/邮箱')" :clearBtn="true" ref="searchBox" :searchBtn="true" :fn="getExistList" @AfterClear="afterClear"></InputText>
			</div>
			<div class="posR h20x-min">
				<Loading v-show="existAccInfo.loading"></Loading>
				<div class="h20x-max lh20 ofH" v-show="existAccInfo.list.length" scroll>
					<ul class="curP_E">
            <li v-for="(item,index) in existAccInfo.list" :key="index" class="hoverBg pl1x pr1x" @click.stop="addExistAccount(item)">
                <div class="pb1x tableSys vaM_E" :class="{ 'bdSub-bottom':index < existAccInfo.list.length-1}">
                    <div>
                        <div class="fs12x mt05x">{{item.name}}</div>
                        <div class="cSub vaM_E">
                            <svg class="dvStatus dpIB mr05x fillMain fSub"><use xlink:href="#phone"></use></svg>{{item.phone?item.phone:'--'}}
                        </div>
                        <div class="cSub vaM_E">
                            <svg class="dvStatus dpIB mr05x alpha-hight fillMain fSub"><use xlink:href="#email"></use></svg>{{item.email?item.email:'--'}}
                        </div>
                    </div>
                    <div class="w5x cSub taC">
                        <span v-if="item.isAdd">{{getLanguageStr('word56','已选')}}</span>
                        <!-- <button type="button" class="fSub" :title="$t('cmd10',['添加'])" v-else>
                            <Icon name="add" class="w1x h1x" :sizeBase="'m'"/>
                        </button> -->
                    </div>

                </div>
            </li>
					</ul>
				</div>
				<div class="h12x-min taC tableSys vaM_E" v-show="!existAccInfo.list.length && !existAccInfo.loading">
          <span>{{$t('word1380',['暂无数据'])}}</span>
				</div>
			</div>
    </div>
  </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import {relatedUser} from '@/api/maintain/plant/relative.js'
import clickoutside from '@/plugins/clickOutSide/index.js'
import { GetRelUserList } from '@/api/manage/externalRelative.js'

import TagBox from '@/components/common/ui/TagBox.vue'
import InputText from '@/components/common/ui/InputText.vue'
import Loading from '@/components/common/ui/Loading'
import SearchRelative from '@/view/manage/account/SearchRelative.vue'
import AddNewAccount from '@/view/manage/account/AddNewAccount.vue'
import EditRelative from '@/view/manage/account/EditRelative.vue'
let timer
export default {
  name: 'relevanceAccount',
  components: {TagBox, InputText, Loading, SearchRelative, AddNewAccount, EditRelative},
  directives: { clickoutside },
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el).find('[scroll]'))
  },
  watch: {
    'account.acountList' (val) {
      this.$emit('UpdateData', val)
    }
  },
  props: {
    stationId: {
      type: Array
    },
    type: { // 'normal' && 'filter'
      type: String,
      default: 'normal'
    },
    maxAddNum: {// 标签默认最大50
      type: Number,
      default: 50
    },
    list: {// 生效的标签列表
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      showAccount: false,
      showAccountMousePos: false,
      existAccInfo: {
        show: false,
        mousePos: false,
        searchKey: '',
        loading: true,
        list: []
      },
      account: {
        acountList: []
      },
      addAccountList: []
    }
  },
  methods: {
    transitionAction: lib.transitionAction,
    getLanguageStr,
    show () {
      this.$nextTick(() => {
        this.account.acountList = _.cloneDeep(this.list)
      })
    },
    handleClose (e) {
      if (!this.existAccInfo.mousePos && !this.showAccountMousePos) {
        this.showAccount = false
        this.existAccInfo.show = false
      }
    },
    showChoose () {
      this.showAccount = true
      this.existAccInfo.show = false
    },
    _showList () {
      if (this.type == 'filter') {
        this.existAccount()
      } else {
        this.showAccount = true
        this.existAccInfo.show = false
      }
    },
    /// ////////////////////////////选择已有用户///////////////////////
    existAccount () {
      this.existAccInfo.searchKey = ''
      this.existAccInfo.list = []
      this.showAccount = false
      this.existAccInfo.show = true
      this.getExistList()
    },
    // 查询存在的用户
    getExistList () {
      this.existAccInfo.list = []
      this.existAccInfo.loading = true
      let requestData = {
        targetEntityName: this.existAccInfo.searchKey,
        'order.direction': 'ASC',
        'order.property': 'createdDate', // createdTime
        page: 1,
        size: 1000
      }
      GetRelUserList(requestData).then(res => {
        this.existAccInfo.loading = false
        if (res.total > 0) {
          this.existAccInfo.list = res.data.filter(el => el.userInfoDto).map(el => ({
            entityRelId: el.entityRel.id,
            name: el.userInfoDto.userInfo.name,
            phone: el.userInfoDto.userInfo.phoneNumber,
            email: el.userInfoDto.userInfo.email,
            isAdd: false,
            entityRel: el.entityRel, // 添加用户时判断里面roleid是否存在
            userInfoDto: el.userInfoDto // 编辑关系时用到这样结构取name
          }))
        }
        if (this.account.acountList.length > 0) {
          this.existAccInfo.list.forEach((el, index) => {
            this.account.acountList.forEach(attr => {
              if (el.entityRelId === attr.entityRelId) {
                el.isAdd = true
              }
            })
          })
        }
        this.existAccInfo.loading = false
      }, error => {
        this.existAccInfo.loading = false
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 添加已有账户
    addExistAccount (item) {
      // console.log(item)
      this.addAccountList = []
      this.addAccountList = item
      this.addAccountList.userInfo = item.userInfoDto.userInfo
      // item.entityRel.roleId = false
      if (!item.entityRel.roleId && this.type == 'normal') {
        this.$refs.EditRelative.show({...item, type: 2, relative: 'edit'})
      } else {
        if (this.account.acountList.length >= this.maxAddNum && !item.isAdd) {
          this.$notify(i18n.t('fill3rd130', [getLanguageStr('word1546', '用户'), this.maxAddNum, '用户数量已超出上限，上限n个']))
          // this.$notify(i18n.t('fill3rd130', [this.maxAddNum, '标签数量已超出上限，上限n个']))
        } else {
          if (!item.isAdd) {
            item.isAdd = !item.isAdd
            this.selectData()
          }
        }
      }
    },
    selectData () {
      this.account.acountList = this.existAccInfo.list.filter(el => el.isAdd)
      this.$emit('Update', this.account.acountList)
    },
    clear () {
      this.account.acountList = []
      this.existAccInfo.list.forEach(el => {
        this.$set(el, 'isAdd', false)
      })
      this.selectData()
    },
    afterClear () {
      this.existAccInfo.searchKey = ''
      this.getExistList()
    },
    onRemove (id, index) {
      // this.account.acountList.splice(index,1)
      this.existAccInfo.list.forEach((el, index) => {
        if (el.entityRelId === id) {
          this.existAccInfo.list[index].isAdd = false
        }
      })
      this.selectData()
    },
    /// ////////////////////添加用户////////////////////////////////
    addAccount (type) {
      this.showAccount = false
      this.$refs.SearchRelative.show(type)
    },
    // 已经建立关系
    AddAccountChoose (item) {
      let isExist = this.account.acountList.filter(el => el.entityRelId == item.entityRelId)
      if (!isExist.length) {
        this.account.acountList.push({
          entityRelId: item.entityRelId,
          name: item.name
        })
      }
    },
    // 建立关系
    AddRelative (data) {
      // trace(data)
      this.addAccountList = []
      this.addAccountList = data
      data.userInfoDto = {}
      data.userInfoDto.userInfo = data.userInfo // 传入的name与外部关系用户列表传入的位置一置
      if (data.entityRel) { // entityRel:{ roleId:''} 这种情况下需要编辑外部关系
        this.$refs.EditRelative.show({...data, type: 2, relative: 'edit'})
      } else {
        this.$refs.EditRelative.show({...data, type: 2, relative: 'add'})
      }
    },
    updateData (id) {
      // console.log(this.addAccountList)
      this.account.acountList.push({
        name: this.addAccountList.userInfo.name,
        entityRelId: id,
        isAdd: true
      })
    },
    /// /////////////////////////创建新用户/////////////////////////////
    buildNewAccount () {
      if (this.showAccount) {
        this.showAccount = false
      }
      this.$dynamic(this.$el, AddNewAccount, {}, {
        updateList: [this.afterBuild.bind(this)]
        // refreshList:[this.getList.bind(this)],
        // Close:[this.closeViewSys.bind(this)],
        // refresh:[this.refresh.bind(this)],
        // update:[this.getList.bind(this)],
        // Follow:[this.Follow.bind(this)]
      }).then(dynamic => {
        dynamic.childInstance.show()
      })
    },
    afterBuild (data, id) {
      this.account.acountList.push({
        name: data.name,
        entityRelId: id,
        isAdd: true
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.chooseList{
    >*{
         line-height: 2.5em;
         cursor: pointer;
    }
    >li:last-child{
        border-bottom: none
    }
}
.bd-last>*:last-child{
    border-bottom: none
}
.dvStatus{
    width: 1.2em;
    height: 1.2em;
}
.enableList{padding:{bottom:.5em;};position:relative;
	.clearTag{position:absolute;top:0;right:.5em;}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/relevance/RelevanceUser.vue